module.exports = __webpack_public_path__ + "img/logo.9286ee7e.png";